import type { ReactNode } from 'react';

import CustomGallery from '../../../components/CustomGallery';
import type {
  EjsBlockFromType,
  EjsBlockGoogleForm,
  EjsBlockImage,
} from '../../../editor/editorjs/@types';
import { type EjsHighlightedEmbed, getComponentFromEjsOutputData } from '../../../utils/editor';

type HighlightedEmbedProps = {
  embedToHighLight: EjsHighlightedEmbed;
};

export const HighlightedEmbed = ({ embedToHighLight }: HighlightedEmbedProps) => {
  const { type, blocks } = embedToHighLight;
  let embedsToDisplay: ReactNode;

  switch (type) {
    case 'image':
      embedsToDisplay = getImageHighlight(blocks as EjsBlockImage[]);
      break;
    case 'googleForm':
      embedsToDisplay = getGoogleFormHighlight(blocks as EjsBlockGoogleForm[]);
      break;
    default:
      embedsToDisplay = getComponentFromEjsOutputData(embedToHighLight);
      break;
  }

  return <div className="HighlightedEmbed flex flex-col gap-y-1">{embedsToDisplay}</div>;
};

const getImageHighlight = (blocks: EjsBlockImage[]) => {
  const actualImagesUrls = blocks.map(block => block.data.file.url);
  return <CustomGallery photos={actualImagesUrls} />;
};

const getGoogleFormHighlight = (blocks: EjsBlockGoogleForm[]) => {
  const formBlocks = blocks as EjsBlockFromType<'googleForm'>[];

  const mutatedForm = {
    type: 'linkTool',
    blocks: formBlocks.map(mutateGformToLinkToolEmbed),
  };

  return getComponentFromEjsOutputData(mutatedForm);
};

const mutateGformToLinkToolEmbed = (
  gformEmbed: EjsBlockFromType<'googleForm'>,
): EjsBlockFromType<'linkTool'> => {
  const { url } = gformEmbed.data;
  const noEmbedUrl = url?.split('?')[0];
  return {
    ...gformEmbed,
    type: 'linkTool',
    data: {
      link: noEmbedUrl,
      meta: {
        title: 'Google form',
        site_name: 'Google',
        description: '',
        image: { url: 'https://www.gstatic.com/images/branding/product/2x/forms_2020q4_48dp.png' },
      },
    },
  };
};
